import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from '@tanstack/react-router';
import { actions } from './Reports.redux';
import api from 'api';

const ModalTemplateAddNew = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const open = useSelector((state) => state.reports.showNewTemplateModal);
    const [baseTemplates, setBaseTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [selection, setSelection] = useState([]);

    const columns = [{ field: 'report_name', headerName: 'Name', flex: 1, sortable: false }];

    const handleClose = () => {
        dispatch(actions.setState({ showNewTemplateModal: false }));
    };

    const handleSetSelection = (newSelection) => {
        setSelection(Array.isArray(newSelection) ? newSelection.slice(-1) : []);
    };

    const handleCreate = async () => {
        if (!selection.length || !title.trim()) {
            return;
        }

        setLoading(true);

        try {
            const selectedTemplate = baseTemplates.find((template) => template.report_id === selection[0]);
            const newTemplate = await api.post('/reports/templates', {
                base_template_id: selectedTemplate.report_id,
                template_name: title.trim(),
            });

            navigate({ to: `/reports/edit-layout/${newTemplate.data.template_id}` });
        } catch (err) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            api.get('/reports/base-templates')
                .then((res) => setBaseTemplates(res.data.templates))
                .catch((err) => console.error(err));
        } else {
            setBaseTemplates([]);
            setSelection([]);
            setTitle('');
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>New Layout</DialogTitle>

            <DialogContent>
                <div>Enter a title, and select a starter template to use as the base of your new layout.</div>

                <Divider sx={{ marginBottom: '12px', marginTop: '12px' }} />

                <div>
                    <TextField label="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                </div>

                <div style={{ marginTop: 16 }}>
                    <DataGrid
                        rows={baseTemplates}
                        columns={columns}
                        getRowId={(row) => row.report_id}
                        rowSelectionModel={selection}
                        onRowSelectionModelChange={handleSetSelection}
                        pagination
                        pageSizeOptions={[5, 10, 20, 30]}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        disableRowSelectionOnClick
                        disableCellFocus
                        autoHeight
                        sx={{
                            '& .MuiDataGrid-row': { cursor: 'pointer' },
                            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                outline: 'none',
                            },
                        }}
                    />
                </div>
            </DialogContent>

            <DialogActions>
                <Button disabled={loading} onClick={handleClose}>
                    Cancel
                </Button>

                <Button disabled={loading || selection.length !== 1 || !title.trim()} onClick={handleCreate}>
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalTemplateAddNew;
